import React from 'react'; // import PropTypes from 'prop-types';

import { MaterialUiCore } from '@gscope-mfe/common-libs'; // function CustomToolTip(props) {
//   const { title, placement = 'bottom' } = props;
//   return (
//     <Tooltip
//       arrow
//       title={title}
//       placement={placement}
//     />
//   );
// }
// CustomToolTip.propTypes = {
//   title: PropTypes.string.isRequired,
//   placement: PropTypes.string.isRequired,
// };

const { Tooltip } = MaterialUiCore;

function CustomToolTip(props) {
    if (props.disable) {
        return <Tooltip title="">{props.children}</Tooltip>;
    }

    return <Tooltip arrow {...props} />;
}

export { CustomToolTip };
